export default {
    confirmation: {
        delete: 'Are you sure you want to delete the <br> <b><em>{entity}</em></b>?<br> <span class="error--text">The action cannot cancel in future!</span>'
    },
    validation: {
        required_field: 'The field is required'
    }
}
